import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function splitParagraphs(value: string): string[] {
  return value.split(/\n{2,}/);
}

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 bg-accent-500/[0.04] rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-500/[0.03] rounded-full -translate-x-1/2 translate-y-1/2 blur-3xl"></div>
      <div className="relative z-10 max-w-[700px] mx-auto px-8 text-center">
        {splitParagraphs(t('coursesMaster.cta.label')).map((paragraph, index) => (
          <p key={index} className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">
            {paragraph}
          </p>
        ))}
        <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-4">
          {t('coursesMaster.cta.title')}
        </h2>
        <div className="gold-line mx-auto mb-6"></div>
        {splitParagraphs(t('coursesMaster.cta.lead')).map((paragraph, index) => (
          <p key={index} className="text-[16px] text-foreground-300 leading-relaxed tracking-[0.04em] mb-10 max-w-lg mx-auto">
            {paragraph}
          </p>
        ))}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
          <Link
            to="/consultation"
            className="btn-glow px-8 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap"
          >
            {t('coursesMaster.cta.consultation')}
          </Link>
          <Link
            to="/brochure"
            className="btn-glow px-8 py-3.5 border border-accent-500/50 text-accent-300 hover:text-accent-200 hover:border-accent-400 hover:bg-accent-500/8 text-[15px] tracking-[0.1em] text-center transition-all duration-300 whitespace-nowrap"
          >
            {t('coursesMaster.cta.brochure')}
          </Link>
        </div>
        {splitParagraphs(t('coursesMaster.cta.note')).map((paragraph, index) => (
          <p key={index} className="text-[13px] text-foreground-500 tracking-[0.04em]">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
}
